/**
 * @generated SignedSource<<d004fbc3abaafa06e796d8440c8bf435>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type linearStreamDetails$data = {
  readonly cycleId: string | null;
  readonly doneStatusId: string | null;
  readonly includeAiGenerated: boolean;
  readonly linearUser: {
    readonly user: {
      readonly fullName: string;
    };
  };
  readonly projectId: string | null;
  readonly statusId: string | null;
  readonly teamId: string;
  readonly teamName: string;
  readonly uncheckedStatusId: string | null;
  readonly " $fragmentType": "linearStreamDetails";
};
export type linearStreamDetails$key = {
  readonly " $data"?: linearStreamDetails$data;
  readonly " $fragmentSpreads": FragmentRefs<"linearStreamDetails">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "linearStreamDetails",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "LinearUserNode",
      "kind": "LinkedField",
      "name": "linearUser",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "fullName",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "teamName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "includeAiGenerated",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "teamId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cycleId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "statusId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uncheckedStatusId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "doneStatusId",
      "storageKey": null
    }
  ],
  "type": "LinearStreamIntegrationNode",
  "abstractKey": null
};

(node as any).hash = "8b8ec57c435c963c6c12dcef6a9366d8";

export default node;
